<template>
    <a role="button" :data-href="disabled ? '#' : link">
        <button
            :class="isOutline ? 'btn btn-outline-primary actionar btn-block' : 'btn btn-primary actionar btn-block'"
            type="button" :disabled="disabled">
            <span>
                <slot></slot>
            </span>
            <br />
            {{ title }}
        </button>
    </a>
</template>

<script>
// import Translations from "./insert-me-to-translate.vue";

export default {
    name: "SkokkaButton",
    props: {
        title: {
            type: String,
            required: false,
        },
        link: {
            type: String,
            required: false,
        },
        isOutline: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
};
</script>